export enum DevToolsCommandType {
  TerminateEtlBatch = 1,
  TerminateLoanValidation = 2,
  ImportAllIfxLoans = 3,
}

export interface DevToolsCommandExecution {
  id: number
  commandType: DevToolsCommandType
  errorMessage: string | null
  executedByUserId: number
  executedByUserFullname: string
  executedOn: string
}
